<template>
    <div style="width: 100%; height:100%;">
        <div class="previewMock"></div>
        <div class="previewContent" :class="media_skin">
            <div class="previewLogo articleHeader" :class="media_skin" :style="logo"></div>
            <div>
                <hr class="brandColor" :class="media_skin" />
            </div>
            <div class="brandColor title" :class="media_skin">{{title}}</div>

            <div v-for="item in struct" :key="item.id">
                <div v-if="item.type == 'subheader'" :class="media_skin" class="subtitle" >{{item.text}}</div>
                <div v-else-if="item.type == 'paragraph'" :class="media_skin" class="maintext">{{item.text}}</div>
                <div v-else-if="item.type == 'image' && item.image" class="article-image" :style="`background-image: url(${checkFileUrl(item.image)});`" />
                <!-- <image-cropper v-else-if="item.type == 'image' && item.image" :initial-image="checkFileUrl(item.image)" v-model="crops[index]" :disabled="true" :show-remove-button="false" @initial-image-loaded="applyMeta(item.meta, index)" /> -->
                <div v-else-if="item.type == 'quote'" class="quoteContainer" :class="media_skin">
                    <i class="fas fa-quote-left" />
                    <div class="quoteText brandColor" :class="media_skin">{{item.text}}</div>
                    <i class="fas fa-quote-right" />
                </div>
                <iframe v-else-if="item.type == 'video' && item.embed_url" style="height:25em; width: 100%; margin-top: 1em; margin-bottom: 1em;" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" :src="item.embed_url + (dashboard ? '&mute=1&background=1&autoplay=0' : '?autoplay=1')"
                    allowfullscreen />
            </div>

        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import Croppa from 'vue-croppa';
import { mapActions, mapGetters } from 'vuex';
Vue.use(Croppa, { componentName: 'image-cropper' });

export default {
    name: "ArticlePreview",
    props: {
        title: String,
        media_skin: String,
        custom_media_skin: Number,
        struct: Array,
        dashboard: Boolean
    },
    watch: {
        media_skin() {
            this.updateMediaSkin()
        }
    },
    data() {
        return {
            logo: "",
            crops: new Array(this.struct.length)
        }
    },
    computed: {
        ...mapGetters([
            'getFileUrl',
            'getMediaSkinFileUrl'
        ])
    },
    mounted() { if (this.$parent.content_id != 0) this.updateMediaSkin() },
    methods: {
        ...mapActions([
            'fetchFiles'
        ]),
        checkFileUrl(image_id) {
            const url = this.getFileUrl(image_id) || this.fetchFiles().then(() => this.getFileUrl(image_id)) || 'https://crisis.ams3.digitaloceanspaces.com/placeholder-image.png'
            if (!url) {
                return
            }
            else return url
        },
        updateMediaSkin() {
            if (this.custom_media_skin)
                this.logo = 'background-image:url(' + this.getMediaSkinFileUrl(this.custom_media_skin) + ')'
            else
                this.logo = 'background-image:url(/img/article/logo_' + this.media_skin + ".svg)"
        },
        applyMeta(meta, index) {
            if (meta) this.crops[index].applyMetadata(meta)
        },
    }
}
</script>

<style scoped>

.article-image {

    width: 100%;
    height: auto;
    background-size: contain;
    background-repeat: no-repeat;
    height: 22em;
    background-position: center;
    position: relative;
}

</style>
